var map = {
	"./action-list/msyst-icon_action-list-white.svg": "Ql++",
	"./action-list/msyst-icon_calvings.svg": "ut99",
	"./action-list/msyst-icon_check-for-pregnancy-blue.svg": "OllD",
	"./action-list/msyst-icon_check-for-pregnancy-orange.svg": "+PwX",
	"./action-list/msyst-icon_cows-blue.svg": "glg1",
	"./action-list/msyst-icon_cows-orange.svg": "Ds37",
	"./action-list/msyst-icon_dry-off.svg": "MKNP",
	"./action-list/msyst-icon_insemination-blue.svg": "+hsc",
	"./action-list/msyst-icon_insemination-orange.svg": "37Ca",
	"./action-list/msyst-icon_lactating.svg": "Jorr",
	"./alert.svg": "936z",
	"./chart/abortion.svg": "mN/D",
	"./chart/calving.svg": "Xd3z",
	"./chart/culled.svg": "hlGE",
	"./chart/decreased_activity.svg": "Zh4w",
	"./chart/drying_off.svg": "7vtg",
	"./chart/error.svg": "SLAU",
	"./chart/fever.svg": "s4cU",
	"./chart/few_water_intake.svg": "kr4a",
	"./chart/heat-dismiss.svg": "a/l6",
	"./chart/heat.svg": "RJIf",
	"./chart/increased_activity.svg": "2IQJ",
	"./chart/insemination.svg": "dvVp",
	"./chart/knife_blood.svg": "cK/K",
	"./chart/list.svg": "cQJS",
	"./chart/low_temp.svg": "rcWf",
	"./chart/pregnancy_check.svg": "YdGt",
	"./fertility-status/msyst-icon_cows-not-in-heat.svg": "h4GJ",
	"./fertility-status/msyst-icon_fertility-status-white.svg": "stWP",
	"./fertility-status/msyst-icon_fresh-cows-active.svg": "DQ7u",
	"./fertility-status/msyst-icon_fresh-cows-normal.svg": "mQur",
	"./fertility-status/msyst-icon_open-cows-active.svg": "H6Q1",
	"./fertility-status/msyst-icon_open-cows-normal.svg": "RRAm",
	"./fertility-status/msyst-icon_pregnant.svg": "e0Zr",
	"./fertility-status/msyst-icon_probably-barren.svg": "NQCs",
	"./fertility-status/msyst-icon_suspicious-cycle.svg": "UDL2",
	"./health-status/msyst-icon_check-health.svg": "qups",
	"./health-status/msyst-icon_drinking-status-active.svg": "C7ga",
	"./health-status/msyst-icon_drinking-status-normal.svg": "QmEQ",
	"./health-status/msyst-icon_drop-in-activity-levels.svg": "mVER",
	"./health-status/msyst-icon_health-status-white.svg": "K1e6",
	"./health-status/msyst-icon_risk-of-sara.svg": "tZlt",
	"./health-status/msyst-icon_suspicious-fresh-cows-active.svg": "r8dG",
	"./health-status/msyst-icon_suspicious-fresh-cows.svg": "id3g",
	"./health-status/msyst-icon_temperature-drop.svg": "FuON",
	"./health-status/msyst-icon_temperature-increase.svg": "2rcK",
	"./messages/culled.svg": "tXQf",
	"./messages/msyst-icon_all-messages-orange.svg": "5pOL",
	"./messages/msyst-icon_feeding-orange.svg": "8lrf",
	"./messages/msyst-icon_fertility-orange.svg": "moel",
	"./messages/msyst-icon_health-orange.svg": "cTou",
	"./messages/msyst-icon_increased-activity-orange.svg": "2Icy",
	"./messages/msyst-icon_knife-orange.svg": "S52W",
	"./messages/msyst-icon_management-orange.svg": "ZPX2",
	"./messages/msyst-icon_messages-read-white.svg": "jcL2",
	"./messages/msyst-icon_messages-unread-white.svg": "Fu1w",
	"./msyst-icon_barn-orange.svg": "knep",
	"./msyst-icon_barn-white.svg": "XB+h",
	"./msyst-icon_barns-orange.svg": "9cD1",
	"./msyst-icon_barns-white.svg": "0eVf",
	"./msyst-icon_bolus-orange.svg": "O7Kg",
	"./msyst-icon_bolus-white.svg": "OGDs",
	"./msyst-icon_boluses-orange.svg": "0YMe",
	"./msyst-icon_boluses-white.svg": "rp21",
	"./msyst-icon_calendar-orange.svg": "Zhvz",
	"./msyst-icon_companies-orange.svg": "i5qf",
	"./msyst-icon_companies-white.svg": "+Iqr",
	"./msyst-icon_company-orange.svg": "8gLu",
	"./msyst-icon_company-white.svg": "rM0c",
	"./msyst-icon_cows-orange.svg": "IJ80",
	"./msyst-icon_cows-white.svg": "g6vx",
	"./msyst-icon_dashboard-orange.svg": "l740",
	"./msyst-icon_dashboard-white.svg": "spXu",
	"./msyst-icon_data-orange.svg": "UVGS",
	"./msyst-icon_data-white.svg": "fKnK",
	"./msyst-icon_diagram.svg": "8mC6",
	"./msyst-icon_edit.svg": "RgA8",
	"./msyst-icon_group-orange.svg": "4ldb",
	"./msyst-icon_group-white.svg": "oTVb",
	"./msyst-icon_groups-orange.svg": "asSw",
	"./msyst-icon_groups-white.svg": "SnzH",
	"./msyst-icon_info-orange.svg": "r45E",
	"./msyst-icon_info-white.svg": "EEKY",
	"./msyst-icon_lorawan-orange.svg": "LJ4i",
	"./msyst-icon_lorawan-white.svg": "qxUS",
	"./msyst-icon_search-orange.svg": "yWCv",
	"./msyst-icon_search-white.svg": "jEA1",
	"./msyst-icon_settings-orange.svg": "ORBB",
	"./msyst-icon_settings-white.svg": "YzlA",
	"./msyst-icon_site-orange.svg": "CDSl",
	"./msyst-icon_site-white.svg": "B3zc",
	"./msyst-icon_sites-orange.svg": "77rn",
	"./msyst-icon_sites-white.svg": "fc9P",
	"./msyst-icon_telephone-orange.svg": "dNau",
	"./msyst-icon_telephone-white.svg": "XZ5/",
	"./msyst-icon_users-orange.svg": "/k4v",
	"./msyst-icon_users-white.svg": "ovfO"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UFRR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/.*\.svg$
// module id = UFRR
// module chunks = 1